import { application } from "./controllers/application"
import MapBoxController from "./controllers/gis/mapbox_controller"
application.register("mapbox", MapBoxController)
